var map = {
	"./Antigua and Barbuda.png": 557,
	"./Azerbaijan.png": 558,
	"./Bahrain.png": 559,
	"./Bangladesh.png": 560,
	"./Belarus.png": 561,
	"./Bhutan.png": 562,
	"./Botswana.png": 563,
	"./Burkina Faso.png": 564,
	"./Costa Rica.png": 565,
	"./Croatia.png": 566,
	"./Czech Republic.png": 567,
	"./Denmark.png": 568,
	"./Dominica.png": 569,
	"./Dominican Republic.png": 570,
	"./Egypt.png": 571,
	"./Eritrea.png": 572,
	"./Ethiopia.png": 573,
	"./Finland.png": 574,
	"./Georgia.png": 575,
	"./Germany.png": 576,
	"./Guinea-Bissau.png": 577,
	"./Haiti.png": 578,
	"./Indonesia.png": 579,
	"./Iraq.png": 580,
	"./Ireland.png": 581,
	"./Israel.png": 582,
	"./Italy.png": 583,
	"./Jordan.png": 584,
	"./Kuwait.png": 585,
	"./Latvia.png": 586,
	"./Lebanon.png": 587,
	"./Liechtenstein.png": 588,
	"./Lithuania.png": 589,
	"./Luxembourg.png": 590,
	"./Malawi.png": 591,
	"./Maldives.png": 592,
	"./Mauritania.png": 593,
	"./Mauritius.png": 594,
	"./Mongolia.png": 595,
	"./Montenegrin.png": 596,
	"./Morocco.png": 597,
	"./Myanmar.png": 598,
	"./Namibia .png": 599,
	"./Netherlands.png": 600,
	"./New Zealand.png": 601,
	"./Nicaragua.png": 602,
	"./Niger.png": 603,
	"./Paraguay.png": 604,
	"./Philippines.png": 605,
	"./Republic of the Congo.png": 606,
	"./Romania.png": 607,
	"./Saint Lucia.png": 608,
	"./San Marino.png": 609,
	"./Singapore.png": 610,
	"./Slovakia.png": 611,
	"./Slovenia.png": 612,
	"./Somalia.png": 613,
	"./Suriname.png": 614,
	"./United Kingdom.png": 615,
	"./Western Sahara.png": 616,
	"./albania.png": 617,
	"./austria.png": 618,
	"./bahamas.png": 619,
	"./barbados.png": 620,
	"./belize.png": 621,
	"./bosnia and Herzegovina.png": 622,
	"./brunei.png": 623,
	"./chile.png": 624,
	"./fiji.png": 625,
	"./france.png": 626,
	"./india.png": 627,
	"./japan.png": 628,
	"./mali.png": 629,
	"./malta.png": 630,
	"./mexico.png": 631,
	"./nauru.png": 632,
	"./palau.png": 633,
	"./peru.png": 634,
	"./portugal.png": 635,
	"./qatar.png": 636,
	"./serbia.png": 637,
	"./spain.png": 638,
	"./sudan.png": 639,
	"./sy.png": 640,
	"./sz.png": 641,
	"./th.png": 642,
	"./tj.png": 643,
	"./tl.png": 644,
	"./tn.png": 645,
	"./to.png": 646,
	"./tz.png": 647,
	"./uy.png": 648,
	"./uz.png": 649,
	"./va.png": 650,
	"./vc.png": 651,
	"./ve.png": 652,
	"./vu.png": 653,
	"./ws.png": 654,
	"./za.png": 655,
	"./zw.png": 656
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags ^\.\/.*\.png$
// module id = 125
// module chunks = 0